module.exports = __webpack_public_path__ + "static/media/everyone.2d353964.svg";